import React from 'react';

export const HomeIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M11.3333 17.5C11.0572 17.5 10.8333 17.2761 10.8333 17V9.66667C10.8333 9.39052 11.0572 9.16667 11.3333 9.16667H17C17.2761 9.16667 17.5 9.39052 17.5 9.66667V17C17.5 17.2761 17.2761 17.5 17 17.5H11.3333ZM3 10.8333C2.72386 10.8333 2.5 10.6095 2.5 10.3333V3C2.5 2.72386 2.72386 2.5 3 2.5H8.66667C8.94281 2.5 9.16667 2.72386 9.16667 3V10.3333C9.16667 10.6095 8.94281 10.8333 8.66667 10.8333H3ZM7 9.16667C7.27614 9.16667 7.5 8.94281 7.5 8.66667V4.66667C7.5 4.39052 7.27614 4.16667 7 4.16667H4.66667C4.39052 4.16667 4.16667 4.39052 4.16667 4.66667V8.66667C4.16667 8.94281 4.39052 9.16667 4.66667 9.16667H7ZM3 17.5C2.72386 17.5 2.5 17.2761 2.5 17V13C2.5 12.7239 2.72386 12.5 3 12.5H8.66667C8.94281 12.5 9.16667 12.7239 9.16667 13V17C9.16667 17.2761 8.94281 17.5 8.66667 17.5H3ZM4.16667 15.3333C4.16667 15.6095 4.39052 15.8333 4.66667 15.8333H7C7.27614 15.8333 7.5 15.6095 7.5 15.3333V14.6667C7.5 14.3905 7.27614 14.1667 7 14.1667H4.66667C4.39052 14.1667 4.16667 14.3905 4.16667 14.6667V15.3333ZM12.5 15.3333C12.5 15.6095 12.7239 15.8333 13 15.8333H15.3333C15.6095 15.8333 15.8333 15.6095 15.8333 15.3333V11.3333C15.8333 11.0572 15.6095 10.8333 15.3333 10.8333H13C12.7239 10.8333 12.5 11.0572 12.5 11.3333V15.3333ZM10.8333 3C10.8333 2.72386 11.0572 2.5 11.3333 2.5H17C17.2761 2.5 17.5 2.72386 17.5 3V7C17.5 7.27614 17.2761 7.5 17 7.5H11.3333C11.0572 7.5 10.8333 7.27614 10.8333 7V3ZM13 4.16667C12.7239 4.16667 12.5 4.39052 12.5 4.66667V5.33333C12.5 5.60948 12.7239 5.83333 13 5.83333H15.3333C15.6095 5.83333 15.8333 5.60948 15.8333 5.33333V4.66667C15.8333 4.39052 15.6095 4.16667 15.3333 4.16667H13Z'
      fill='#293142'
    />
  </svg>
);

export const EmployeesIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M2.1665 18.332C1.89036 18.332 1.66455 18.1074 1.68497 17.832C1.94067 14.3836 4.81947 11.6654 8.33317 11.6654C11.8469 11.6654 14.7257 14.3836 14.9814 17.832C15.0018 18.1074 14.776 18.332 14.4998 18.332H13.8332C13.557 18.332 13.3358 18.1075 13.3086 17.8327C13.058 15.3057 10.9261 13.332 8.33317 13.332C5.74026 13.332 3.60833 15.3057 3.35779 17.8327C3.33054 18.1075 3.10931 18.332 2.83317 18.332H2.1665ZM8.33317 10.832C5.57067 10.832 3.33317 8.59453 3.33317 5.83203C3.33317 3.06953 5.57067 0.832031 8.33317 0.832031C11.0957 0.832031 13.3332 3.06953 13.3332 5.83203C13.3332 8.59453 11.0957 10.832 8.33317 10.832ZM8.33317 9.16536C10.1748 9.16536 11.6665 7.6737 11.6665 5.83203C11.6665 3.99036 10.1748 2.4987 8.33317 2.4987C6.4915 2.4987 4.99984 3.99036 4.99984 5.83203C4.99984 7.6737 6.4915 9.16536 8.33317 9.16536ZM15.031 12.7073C15.1443 12.4553 15.4416 12.3415 15.6842 12.4736C17.6209 13.5286 18.9764 15.5158 19.1481 17.8324C19.1685 18.1078 18.9426 18.332 18.6665 18.332H17.9998C17.7237 18.332 17.5025 18.1075 17.4752 17.8327C17.3125 16.192 16.3568 14.7846 14.9967 13.9991C14.7577 13.8611 14.644 13.5673 14.7572 13.3156L15.031 12.7073ZM14.5095 3.3813C14.5915 3.09436 14.9067 2.94099 15.1666 3.08764C16.5597 3.87374 17.4998 5.36759 17.4998 7.08203C17.4998 9.28592 15.9463 11.1253 13.874 11.5653C13.5866 11.6263 13.3332 11.3935 13.3332 11.0997V10.4028C13.3332 10.154 13.5181 9.94757 13.7564 9.87609C14.9581 9.51566 15.8332 8.4015 15.8332 7.08203C15.8332 6.08095 15.3295 5.19804 14.5615 4.67284C14.3617 4.53623 14.249 4.29301 14.3155 4.06033L14.5095 3.3813Z'
      fill='#293142'
    />
  </svg>
);

export const MealPlanIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M16.6667 18.3346H3.33333C2.8731 18.3346 2.5 17.9616 2.5 17.5013V2.5013C2.5 2.04107 2.8731 1.66797 3.33333 1.66797H16.6667C17.1269 1.66797 17.5 2.04107 17.5 2.5013V17.5013C17.5 17.9616 17.1269 18.3346 16.6667 18.3346ZM15.8333 16.668V3.33464H4.16667V16.668H15.8333ZM5.83333 5.5013C5.83333 5.22516 6.05719 5.0013 6.33333 5.0013H8.66667C8.94281 5.0013 9.16667 5.22516 9.16667 5.5013V7.83464C9.16667 8.11078 8.94281 8.33464 8.66667 8.33464H6.33333C6.05719 8.33464 5.83333 8.11078 5.83333 7.83464V5.5013ZM5.83333 10.5013C5.83333 10.2252 6.05719 10.0013 6.33333 10.0013H13.6667C13.9428 10.0013 14.1667 10.2252 14.1667 10.5013V11.168C14.1667 11.4441 13.9428 11.668 13.6667 11.668H6.33333C6.05719 11.668 5.83333 11.4441 5.83333 11.168V10.5013ZM5.83333 13.8346C5.83333 13.5585 6.05719 13.3346 6.33333 13.3346H13.6667C13.9428 13.3346 14.1667 13.5585 14.1667 13.8346V14.5013C14.1667 14.7774 13.9428 15.0013 13.6667 15.0013H6.33333C6.05719 15.0013 5.83333 14.7774 5.83333 14.5013V13.8346ZM10.8333 6.33463C10.8333 6.05849 11.0572 5.83464 11.3333 5.83464H13.6667C13.9428 5.83464 14.1667 6.05849 14.1667 6.33464V7.0013C14.1667 7.27744 13.9428 7.5013 13.6667 7.5013H11.3333C11.0572 7.5013 10.8333 7.27744 10.8333 7.0013V6.33463Z'
      fill='#293142'
    />
  </svg>
);

export const PaymentsIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M6.0639 9.712L11.1679 16H7.8559L2.3999 9.184V7.888H4.1119C6.0959 7.888 7.5199 7.136 7.8559 5.856H2.3999V4.032H7.8559C7.5199 2.784 6.4159 2.112 4.6879 2.112H2.4159V0H13.5999V1.968H9.6639L9.6479 2.08C10.3039 2.56 10.6559 3.296 10.7679 4.032H13.5999V5.856H10.7519C10.3199 8.048 8.1919 9.408 6.0639 9.712Z'
      fill='#293142'
    />
  </svg>
);

export const ReportsIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M12.5 3.33464H4.16667V16.668H15.8333V6.66797H13C12.7239 6.66797 12.5 6.44411 12.5 6.16797V3.33464ZM2.5 2.49447C2.5 2.03801 2.87291 1.66797 3.33208 1.66797H13.3333L17.4998 5.83464L17.5 17.4951C17.5 17.9587 17.1292 18.3346 16.6722 18.3346H3.32783C2.87063 18.3346 2.5 17.9552 2.5 17.5081V2.49447ZM9.50174 6.70496C9.77483 6.66403 10 6.89183 10 7.16797V10.0013H12.8333C13.1095 10.0013 13.3373 10.2265 13.2963 10.4996C13.0558 12.1041 11.6716 13.3346 10 13.3346C8.15905 13.3346 6.66667 11.8422 6.66667 10.0013C6.66667 8.32968 7.89713 6.94546 9.50174 6.70496Z'
      fill='#293142'
    />
  </svg>
);

export const PayOnlineIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M1.5 15H16.5V16.5H1.5V15ZM3 9H4.5V14.25H3V9ZM6.75 9H8.25V14.25H6.75V9ZM9.75 9H11.25V14.25H9.75V9ZM13.5 9H15V14.25H13.5V9ZM1.5 5.25L9 1.5L16.5 5.25V8.25H1.5V5.25ZM3 6.17705V6.75H15V6.17705L9 3.17705L3 6.17705ZM9 6C8.58577 6 8.25 5.66421 8.25 5.25C8.25 4.83579 8.58577 4.5 9 4.5C9.41423 4.5 9.75 4.83579 9.75 5.25C9.75 5.66421 9.41423 6 9 6Z'
      fill='white'
    />
  </svg>
);
